import { render, staticRenderFns } from "./BgpList.vue?vue&type=template&id=d471b1ec&scoped=true&"
import script from "./BgpList.vue?vue&type=script&lang=js&"
export * from "./BgpList.vue?vue&type=script&lang=js&"
import style0 from "./BgpList.vue?vue&type=style&index=0&id=d471b1ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d471b1ec",
  null
  
)

export default component.exports